import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLoader } = FiIcons;

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center py-8">
      <div className="flex items-center space-x-3">
        <SafeIcon icon={FiLoader} className="animate-spin text-2xl text-indigo-600" />
        <span className="text-gray-600">Getting your location...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;